import { ThemeOptions } from "@mui/material";

export const chipOverrides: ThemeOptions["components"] = {
	MuiChip: {
		styleOverrides: {
			root: {
				lineHeight: 1,
				borderRadius: "8px !important",
			},
			sizeMedium: {
				height: "30px",
			},
			labelMedium: {
				fontSize: "14px",
			},
			labelSmall: {
				fontWeight: 600,
				fontSize: "12px",
			},
		},
	},
};
